import { api } from '../utils/apiClient';

export const analyticsService = {
  // range ({from, to}, optional) only scopes FUNNEL — MONTHS/MAU/DAU/SESS/
  // SESS_SPARK/RET_SPARK stay fixed 12-month/week rolling windows regardless
  // (see queries.service.js's getDashboardMetrics comment for why).
  async getDashboard(range) {
    return api.get('/analytics/dashboard', range);
  },

  async getKPIs() {
    return api.get('/analytics/kpis');
  },

  // Distinct users active in the last 5 minutes — a "live now" approximation.
  async getLiveCount() {
    return api.get('/analytics/live-count');
  },

  // range ({from, to}, optional) reinterprets this as "new profiles created
  // in this window, by city" — omitted, it's the original all-time snapshot.
  async getGeos(range) {
    return api.get('/analytics/geos', range);
  },

  async getFeed() {
    return api.get('/feed');
  },

  // range ({from, to}, optional) only scopes PLATFORM_DATA/TOP_EVENTS —
  // MONTHS/MAU/DAU/RETENTION_COHORT stay fixed rolling windows regardless.
  async getAnalyticsPage(range) {
    return api.get('/analytics/full', range);
  },

  // steps: ordered event-name array (>=2) — per-step user counts + conversion
  // rate relative to step 1, each user's own 30-day window from their first
  // step-1 event. Backend: getFunnel() in services/analytics/queries.service.js.
  async funnel(steps) {
    return api.post('/analytics/funnel', { steps });
  },
};
